import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import About from '../components/about.vue';
import Notificacion from '../components/Notificacion.vue';
import Comunicado from '../components/Comunicado.vue';
import ComunicadoUsuario from '../components/ComunicadoUsuario.vue';
import Grupo from '../components/Grupo.vue';
import GrupoUsuario from '../components/GrupoUsuario.vue';
import Login from '../components/Login.vue';
import store from '../store/index.js';
import Beneficio from '../components/Beneficio.vue';
import Jerarquia from '../components/Jerarquia.vue';
import Area from '../components/Area.vue';
import UsuarioArea from '../components/UsuarioArea.vue';
import Vacacion from '../components/Vacacion.vue';
import PrestacionGrupo from '../components/PrestacionGrupo.vue';
import PrestacionArea from '../components/PrestacionArea.vue';
import Enlace from '../components/Enlace.vue';
import EnlaceUsuario from '../components/EnlaceUsuario.vue';
import DatoUsuario from '../components/DatoUsuario.vue';
// import Curso from '../components/Curso.vue'

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/login/idusuario/:idusuario/__token/:__token',
    name: 'Login',
    component: Login,
  },
  {
    path: '/notificacion',
    name: 'notificacion',
    component: Notificacion,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/comunicado',
    name: 'comunicado',
    component: Comunicado,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/beneficio',
    name: 'beneficio',
    component: Beneficio,
  },
  {
    path: '/usuarioArea',
    name: 'usuarioArea',
    component: UsuarioArea,
  },
  {
    path: '/comunicadousuario',
    name: 'comunicadousuario',
    component: ComunicadoUsuario,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/jerarquia',
    name: 'jerarquia',
    component: Jerarquia,
  },
  {
    path: '/grupo',
    name: 'grupo',
    component: Grupo,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/grupousuario',
    name: 'grupousuario',
    component: GrupoUsuario,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/prestaciongrupo',
    name: 'prestaciongrupo',
    component: PrestacionGrupo,
    meta: {
      requiresAuth: true,
    },
  }, 
  {
    path: '/prestacionarea',
    name: 'prestacionarea',
    component: PrestacionArea,
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: '/area',
    name: 'area',
    component: Area,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/about',
    name: 'about',
    component: About,
    meta: {
      requiresAuth: true,
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    //component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/vacacion',
    name: 'Vacacion',
    component: Vacacion,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/enlace',
    name: 'Enlace',
    component: Enlace,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/enlaceusuario',
    name: 'enlaceusuario',
    component: EnlaceUsuario,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/datousuario',
    name: 'Actualizar Datos de Usuario',
    component: DatoUsuario,
    meta: {
      requiresAuth: true,
    },
  },
  // {
  //   path: '/curso',
  //   name: 'Curso',
  //   component: Curso,
  //   meta: {
  //     requiresAuth: true,
  //   },
  // },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  let isLogin = router.app.$isLogin;
  let uriUsuarios = router.app.$uriUsuarios;
  //console.log('router.beforeEach isLogin');
  //console.log(isLogin);
  // console.log(uriUsuarios)
  if (to.matched.some((route) => route.meta.requiresAuth)) {
    if (store.state.sIsLogin) {
      next();
    } else {
      // next({ path: '/login' })
      window.location = uriUsuarios;
    }
  }
  next();
});

export default router;

/*
to.matched.some((record) => {
    // check if there is meta data
    // console.log('navego a ')
    // console.log(to)
    // console.log('navego a ')
    // console.log(from)
    
    if (to.matched.some(record => record.meta.requiresAuth)) {
      if (!isLoggedIn) {
        next({
          path: '/login',
          replace: true
        })
      } else {
        next()
      }
    } else {
      next()
    }
  })
*/
